import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { fetchAccountAvailableDomains } from "features/Accounts/state/thunks/accountDomainsThunk";
import { setSelectedDomain, setSelectedDomainType } from "features/Accounts/state/slices/accountDomainsSlice";
import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import { DomainsSection } from "../../../../../../components/DomainsSection/DomainsSection";

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  return {
    availableDomains: state.accounts.availableDomains,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: AppDispatch, ownProps: { accountId: number }) => ({
  getAvailableDomains: () => dispatch(fetchAccountAvailableDomains(ownProps.accountId)),
  setSelectedDomainAction: bindActionCreators(setSelectedDomain, dispatch),
  setSelectedDomainTypeAction: bindActionCreators(setSelectedDomainType, dispatch),
});

/* istanbul ignore next */
const connector = connect(mapStateToProps, mapDispatchToProps);

const DomainsSectionContainer = connector(DomainsSection);
export default DomainsSectionContainer;
